import { WarningCircleIcon } from "@phosphor-icons/react";
import { goToUrl } from "apps/visits/core/utils/go-to-url";
import { useTranslation } from "react-i18next";
import { Button } from "@/core/shared/v2/ui/button";
import { Card } from "../card";

export const GetOrderError = () => {
  const { t } = useTranslation("translation");
  return (
    <div className="mx-auto flex max-w-[800px] flex-col px-4 pt-10">
      <Card className="flex flex-col items-center text-center">
        <WarningCircleIcon className="size-8 text-black" />
        <p className="mt-4">{t("GROUP_ACTIONS_ORDERING.ERRORS.GET_ORDER_API_ERROR")}</p>
        <Button variant="primary" size="lg" className="mt-6 w-full md:w-auto" onClick={() => goToUrl("/")}>
          {t("GROUP_ACTIONS_ORDERING.GENERAL.BACK_TO_HOME")}
        </Button>
      </Card>
    </div>
  );
};
